import BaseService from '@/scripts/services/base/base.service'

export default class GeneralService extends BaseService {
    constructor() {
        super('Finance')
    }

    getFinanceDetails(filters) {
        return this.postRequest('GetFinanceDetails', filters)
    }

    confirmPayment(financeConfirmDetails) {
        return this.postRequest('ConfirmPayment', financeConfirmDetails)
    }

    cancelPayment(donationId) {
        return this.getRequest('CancelPayment', { donationId: donationId })
    }

    returnDonationToPending(donationId) {
        return this.getRequest('ReturnDonationToPending', {
            donationId: donationId,
        })
    }
}
